import React, { FC } from 'react'
import { Icon } from '@wmgtech/legato'

import { HeaderCountriesList } from '..'

import { ZoneMenuItemProps } from './ZoneMenu.props'

const ZoneMenuItem: FC<ZoneMenuItemProps> = ({ type, options, onSelect, value }) => {
  return (
    <>
      <div className="zone-menu-container__item-heading">
        <Icon className="zone-menu-container__icon" name="circle-location-arrow" />
        {type}
      </div>
      <HeaderCountriesList
        options={options}
        onSelect={onSelect}
        activeItemId={value}
        hasSubtitle={type === 'SPACES'}
        hasTooltip={type === 'SPACES'}
      />
    </>
  )
}

export default ZoneMenuItem
